import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { useDeviceType } from '@cian/ui-kit/responsive';

export interface IGeoLocationButtonProps {
  text: string;

  onClick(): void;
}

export const GeoLocationButton: React.FC<IGeoLocationButtonProps> = props => {
  const { onClick, text } = props;
  const size = useDeviceType() === 'desktop' ? 'XS' : 'M';

  return (
    <Button onClick={onClick} theme="stroke_secondary" size={size}>
      {text}
    </Button>
  );
};

GeoLocationButton.displayName = 'GeoLocationButton';
